import { ClientReportFilter } from './client-report-filter.model';
import { ReportGenerateData } from './report-generate-data.model';

/** Body of POST api/ClientReport/batch. Response is the new batch id (number). */
export class ClientReportBatchRequest {
    reportFileName: string;
    reports: string[];                       // native report codes, e.g. ["attendance"]
    filter: ClientReportFilter;
    reportRequests: ReportGenerateData[];    // one line per placement (server maps to ReportGenerationDataEntity)
    format?: 'xlsx' | 'pdf';                 // omitted = xlsx; 'pdf' needs the reports.batch-pdf switch (404 while off)
}
